var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { toURLSearchParams } from "utils";
export function makeSearchQueryFromURLParams(query) {
    const searchParams = new URLSearchParams(query);
    const queryObj = [...searchParams.keys()].reduce((acc, x) => {
        const values = searchParams.getAll(x);
        acc[x.toLowerCase()] = values.length > 1 ? values : values[0];
        return acc;
    }, {});
    const page = parseInt(queryObj['page']) || 0;
    delete queryObj['page'];
    return [queryObj, page];
}
export function makeSearchId(query, page) {
    const { page: _ } = query, queryBlob = __rest(query, ["page"]);
    const searchParams = toURLSearchParams(queryBlob);
    searchParams.set('page', page + '');
    return searchParams.toString();
}
export function mapExtrasToJsonCompatibility(extras) {
    return Object.keys(extras).filter(key => { var _a; return !!((_a = extras[key]) === null || _a === void 0 ? void 0 : _a.length); }).map(key => ({ key, value: extras[key] }));
}
export function getExtraKey(e) {
    return e.groupByPackage ? `${e.packageId}-${e.day}` : e.compositeId;
}
